// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  release: '20250715-070029',
  appName: 'WebLogin',
  production: false,
  redirects: {
  	noObligadosRUT: window.location.origin + '/WebRegistroNoObligadosRUT'
  },
  captchaKey: '6LfPTd8mAAAAAI8JTLzFdG0jOUfWe12EkX67xcAt',
  apiOTPDev: '',
  apiOTPPruebas: 'https://apipruebasazure.dian.gov.co',
  apiOTPProd: 'https://apiazure.dian.gov.co',
  captchaKeyCloudflare: '0x4AAAAAAAhQaZpEBg_olxnZ'
};



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/environments/environment.ts